export default new class loginForm {
  constructor() {
    this.loginFormSelector = 'login__form';
    this.submitBtnSelector = 'login__submit';
    this.inValidSelector = '_invalid';
    this.successSelector = 'login__success';
    this.successVisibleSelector = 'login__success_visible';
    this.preLoaderSelector = 'login__preloader';
    this.delay = 2000;

    this.handler();
  }

  handler() {
    const form = document.querySelector(`.${this.loginFormSelector}`);

    if (!form) return;

    const submitBtn = form.querySelector(`.${this.submitBtnSelector}`);

    submitBtn.addEventListener('click', () => {
      setTimeout(() => {
        this.checkForm(form);
      }, 0);
    });
  }

  checkForm(form) {
    const isValid = !form.classList.contains(this.inValidSelector);

    if (!isValid) return;

    $(form)
      .request('EokLogin::onAjax', {
        complete: (res) => {
          this.showTooltip(res);
        },
      });
  }

  showTooltip(res) {
    clearTimeout(this.timer);
    const { responseJSON } = res;

    if (!responseJSON.message) return;

    const tooltip = document.querySelector(`.${this.successSelector}`);
    tooltip.classList.add(this.successVisibleSelector);
    if (!responseJSON.status) {
      tooltip.classList.add('tooltip__error');
    } else {
      tooltip.classList.remove('tooltip__error');
    }
    tooltip.innerHTML = responseJSON.message;

    this.timer = setTimeout(() => {
      tooltip.classList.remove(this.successVisibleSelector);
    }, 2000);
  }
}();
